import { Dayjs } from "dayjs"

import { caseConverterClient } from "~/shared/api/client"
import { Embed } from "~/shared/api/embed"
import { IntegrationKey } from "~/shared/api/integrations"
import { User } from "~/shared/api/users"

import { StarterUsagePlan, UsageOverageOption } from "./billing"

export interface Org {
  id: number
  createdAt?: string
  name: string
  subdomain: string
  countryCode: string
  trialEnd: Dayjs | null
  salesforceId?: string
  pricingPlan?: PricingPlan
  importerLimit?: number
  dataRetentionDurationInMinutes: number
  isTest: boolean
  isSelfServe: boolean
  disableDataMask: { [key in IntegrationKey]?: boolean }
  parentOrg?: Org
  logoUrl?: string
  users: User[]

  usagePlan?: StarterUsagePlan
  usageOverageOption?: UsageOverageOption
  stytchSsoConnectionId?: string

  embed?: Embed
}

const ADMIN_ORG_SUBDOMAIN = "admin"
const ADMIN_ORG_ID = 12

export function orgIsInternalAdmin(org: Org) {
  // NOTE: id-based logic is legacy. Will be removed eventually.
  return org.subdomain === ADMIN_ORG_SUBDOMAIN || org.id === ADMIN_ORG_ID
}

export enum PricingPlan {
  Starter = "Starter",
  Pro = "Pro",
  Enterprise = "Enterprise",
}

export interface UserJwtPayload {
  iss?: string
  // TODO: sub?: string
  user_id?: string
}

export async function generateSandboxUserJWT<TJwtPayload extends UserJwtPayload>(
  jwtPayload: TJwtPayload,
) {
  return caseConverterClient.post<{ jwt: string }>(
    "/api/orgs/generate-sandbox-user-jwt",
    {
      jwtPayload: JSON.stringify(jwtPayload),
    },
  )
}
